import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {Link} from 'react-router-dom';
import {getLinkPath, scrollToTop} from 'app/utils';
import CasinoTournamentTimer from './CasinoTournamentTimer';

interface CasinoTournamentProps {
    bannerImageUrl: string
    style?: React.CSSProperties
    promotionSlug?: string
    promotionEndTime?: number | null
    onExpire: () => void
    filterGroupId: number | null
    onGoToTournamentGames: (filterGroupId: number) => void
}

const CasinoTournament = (
    {bannerImageUrl, style, promotionSlug, promotionEndTime, onExpire, filterGroupId, onGoToTournamentGames}: CasinoTournamentProps
): React.ReactElement => {
    const handleListOfGamesClick = useCallback(() => onGoToTournamentGames(filterGroupId), [filterGroupId, onGoToTournamentGames]);
    const showListOfGamesButton = Boolean(filterGroupId && filterGroupId > 0);

    return <div className="casino-tournament big-marketing-block marketing-block" style={style}>
        <div className="casino-tournament__header">
            <div className="casino-tournament__header-left">
                <span className="casino-tournament__title">
                    <SpriteIcon name="#svg-tournament" className="casino-tournament__icon svg-default" size={{height: 20, width: 20}}/>
                    {I18n.t('casino_tournament_block.tournament')}
                </span>
                {promotionEndTime && <CasinoTournamentTimer
                    promotionEndTime={promotionEndTime}
                    onExpire={onExpire}
                />}
            </div>
            <div className="casino-tournament__links">
                <Link to={getLinkPath(`/promotions/${promotionSlug}`)} className="casino-tournament__link" onClick={scrollToTop}>
                    <SpriteIcon name="#svg-info-transparent" className="svg-default"/>
                    {I18n.t('casino_tournament_block.about_tournament')}
                </Link>
                {showListOfGamesButton && <button
                    type="button"
                    className="casino-tournament__link"
                    onClick={handleListOfGamesClick}
                >
                    <SpriteIcon name="#svg-cards" className="svg-default"/>
                    {I18n.t('casino_tournament_block.list_of_games')}
                </button>}
            </div>
        </div>
        <div className="big-marketing-block__banner">
            <img src={bannerImageUrl} alt="Tournament Banner" />
        </div>
    </div>;
};

export default CasinoTournament;
